import {Injectable} from '@angular/core';
import * as _ from 'lodash-es';
import {takeUntil, tap} from 'rxjs/operators';
import {destroy$} from '../../../destroyable';
import {DexMdSubjectService} from '../../../dex/dex-streaming/subjects/dex-md-subject-service';
import {Deliverable, DeliverableId} from '../../../dex/dex-streaming/types/deliverable';
import {TrancheId} from '../../../dex/dex-streaming/types/tranche';
import {DexTrancheUtilityService} from '../../../dex/dex-tranche-utility/dex-tranche-utility.service';
import {DeliverableCommonFilter} from './deliverable-common-filter';

@Injectable()
export class DeliverableDepositFilter implements DeliverableCommonFilter {

    public query: boolean = true;

    private trancheId: TrancheId;

    private dIdSet: ReadonlySet<DeliverableId> | undefined = undefined;

    private readonly destroy$ = destroy$();

    constructor(
        private readonly dexMdSubjectService: DexMdSubjectService,
        private readonly dexTrancheUtilityService: DexTrancheUtilityService
    ) {}

    public config(options?: {
        trancheId: TrancheId,
        query?: boolean
    }): DeliverableDepositFilter {
        _.assign(this, options);

        this.initFilters();

        return this;
    }

    public apply(): void {
        // Not implemented.
    }

    public match(item: Deliverable): boolean {
        return this.dIdSet?.has(item.deliverableId);
    }

    private initFilters(): void {
        this.initDIds();

        this.dexMdSubjectService.trancheDelRulesUpdated$.pipe(
            tap(() => this.initDIds()),
            takeUntil(this.destroy$)
        ).subscribe();
    }

    private initDIds(): void {
        this.dIdSet = this.dexTrancheUtilityService.getDelAllowedForBuySet(this.trancheId);
    }

}
